import RoomService, {
  TokboxRecordResponse,
  TwilioRecordResponse
} from "@/services/room.service";
import { onMounted, reactive, toRefs } from "@vue/composition-api";
import moment from "moment";
interface UseRecordTableState {
  loading: boolean;
  records: {
    twilio: TwilioRecordResponse[];
    tokbox: TokboxRecordResponse[];
  };
  viewEngine?: string;
  columns: {
    twilio: object[];
    tokbox: object[];
  };
  pagination: Pagination;
  filter: {
    start?: string;
    end?: string;
  };
}
interface UseRecordTableParams {
  roomId: string;
}
interface Pagination {
  pageSize: number;
  // current: number;
  // total: number;
}

const columns = {
  twilio: [
    {
      title: "sid",
      dataIndex: "sid",
      width: "200px",
      scopedSlots: { customRender: "twilioSid" }
    },
    {
      title: "Date",
      width: "150px",
      dataIndex: "dateCreated",
      scopedSlots: { customRender: "date" }
    },
    {
      title: "Duration",
      dataIndex: "duration",
      scopedSlots: { customRender: "duration" }
    },
    {
      title: "Action",
      dataIndex: "id",
      scopedSlots: { customRender: "action" }
    }
  ],
  tokbox: [
    {
      title: "tokboxSid",
      dataIndex: "sessionId",
      width: "200px",
      scopedSlots: { customRender: "sessionId" }
    },
    {
      title: "Duration",
      dataIndex: "duration",
      scopedSlots: { customRender: "duration" }
    },
    {
      title: "Action",
      dataIndex: "url",
      scopedSlots: { customRender: "action" }
    }
  ]
};
const useRecordTable = ({ roomId }: UseRecordTableParams) => {
  const state = reactive<UseRecordTableState>({
    loading: true,
    records: {
      twilio: [],
      tokbox: []
    },
    viewEngine: "twilio",
    filter: {
      start: undefined,
      end: undefined
    },
    columns,
    pagination: {
      pageSize: 5
    }
  });

  const fetchTwilioRecord = async () => {
    const data = await RoomService.getTwilioRecord({
      roomId,
      start: state.filter.start
        ? moment(state.filter.start).toISOString()
        : undefined,
      end: state.filter.end ? moment(state.filter.end).toISOString() : undefined
    });
    state.records.twilio = data;
  };

  const createComposition = async (roomSid: string) => {
    const res = await RoomService.createTwilioComposition(roomId, roomSid);
    if (res) {
      fetchRecord();
    }
    return res;
  };

  const removeComposition = async (compositionSid: string) => {
    const res = await RoomService.removeTwilioComposition(
      roomId,
      compositionSid
    );
    if (res) {
      fetchRecord();
    }
    return res;
  };

  const fetchTokboxRecord = async () => {
    const data = await RoomService.getTokboxRecord(roomId);
    state.records.tokbox = data;
  };

  const fetchRecord = async () => {
    state.loading = true;
    if (state.viewEngine === "twilio") {
      await fetchTwilioRecord();
    }
    if (state.viewEngine === "tokbox") {
      await fetchTokboxRecord();
    }
    state.loading = false;
  };

  onMounted(() => {
    fetchRecord();
  });
  return {
    ...toRefs(state),
    createComposition,
    fetchRecord,
    removeComposition
  };
};

export default useRecordTable;
